import { useState } from "react"
import { Button } from "src/@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/@/components/ui/dialog"
import { Input } from "src/@/components/ui/input"
import { Label } from "src/@/components/ui/label"
import { RowInput } from "src/components/forms/RowInput"

export default function ModalReasons({
  open,
  onClose,
  onSubmit,
  action,
  nome,
  changeNome
}) {

  return (
    <Dialog open={open} onOpenChange={onClose}>

      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            {action === "Criar" ? "Criar motivo de perda" : "Editar motivo de perda"}
            </DialogTitle>

        </DialogHeader>
        <div className="grid gap-4 py-4">
          <RowInput
            label="Nome"
            input={<Input
              onChange={changeNome}
              value={nome}
            />}
          />
        </div>
        <DialogFooter>
          <Button onClick={onSubmit}>{action === "Criar" ? "Criar" : "Salvar"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
